module.exports = __webpack_public_path__ + "assets/logo-small.ff015b95.svg";